// test1770
(1770 && 0);
